var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 55,
    viewBox: "0 0 59 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3079 20.6404C25.3079 20.6404 25.3428 21.3153 25.9452 21.3153C27.4219 21.3153 34.9872 21.1884 34.9872 21.1884L35.2039 19.9066L28.6359 19.2427L25.3097 20.6404H25.3079Z",
    fill: "#AB5A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.202 19.9062C35.202 19.9062 36.506 19.6836 36.8623 19.645C37.1341 19.6156 37.9423 20.96 37.9056 21.1108C37.8688 21.2597 37.4813 21.1108 37.4813 21.1108C37.4813 21.1108 37.4941 21.4105 37.3711 21.4013C37.248 21.3921 37.1213 21.2671 37.1213 21.2671C37.1213 21.2671 37.2646 21.6423 37.1213 21.6496C36.978 21.657 36.7319 21.1567 36.7319 21.1567C36.7319 21.1567 35.3985 21.6809 34.9871 21.1898L35.2038 19.908L35.202 19.9062Z",
    fill: "#AB5A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0471 48.966L16.8608 49.6409C17.1069 49.8451 17.4357 49.9205 17.7461 49.8451L22.4131 48.703L20.8464 46.8345L16.0471 48.9641V48.966Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8918 25.9442V26.8766C36.8918 27.8808 37.4924 28.7875 38.4181 29.1755C39.724 29.7254 41.4064 30.4261 41.4634 30.4261C41.557 30.4261 43.4966 28.3902 43.4966 28.3902L40.3614 25.9424H36.8937L36.8918 25.9442Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1496 20.4141H35.3617C35.0109 20.4141 34.7244 20.6991 34.7244 21.0522V22.3764C34.7244 22.5713 34.7795 22.7626 34.8842 22.9263L35.9366 24.5833C36.1974 24.9934 36.6051 25.2858 37.0772 25.4017L38.7596 25.8136L40.5816 25.0228L38.4437 20.4159H36.1478L36.1496 20.4141Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8035 22.4868H39.375V21.2086H34.8035V22.4868Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3669 25.3243L41.533 24.2577L43.4468 24.0075C44.1099 23.9211 44.356 23.0862 43.8472 22.6521L42.286 21.3243C41.5954 20.7358 40.7175 20.4121 39.8102 20.4121H36.1497C36.1497 21.1845 36.6658 21.8613 37.4096 22.0618L38.9194 22.4719L38.0782 22.9979C37.6906 23.2406 37.6153 23.774 37.9202 24.1142L38.9984 25.3207H42.365L42.3669 25.3243Z",
    fill: "#57B563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9693 48.4729L41.5918 50.4738C41.1693 51.0862 40.4751 51.4522 39.7331 51.4522H25.6401C25.0561 51.4522 24.494 51.226 24.0734 50.8196L21.3845 48.2246L42.9711 48.4747L42.9693 48.4729Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9479 55C54.905 55 58.1128 51.7879 58.1128 47.8257C58.1128 43.8634 54.905 40.6514 50.9479 40.6514C46.9908 40.6514 43.783 43.8634 43.783 47.8257C43.783 51.7879 46.9908 55 50.9479 55Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.948 51.4504C52.9473 51.4504 54.5681 49.8275 54.5681 47.8255C54.5681 45.8236 52.9473 44.2007 50.948 44.2007C48.9487 44.2007 47.3279 45.8236 47.3279 47.8255C47.3279 49.8275 48.9487 51.4504 50.948 51.4504Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9479 50.6302C52.4948 50.6302 53.7489 49.3746 53.7489 47.8256C53.7489 46.2767 52.4948 45.021 50.9479 45.021C49.401 45.021 48.147 46.2767 48.147 47.8256C48.147 49.3746 49.401 50.6302 50.9479 50.6302Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16493 55C11.122 55 14.3299 51.7879 14.3299 47.8257C14.3299 43.8634 11.122 40.6514 7.16493 40.6514C3.20785 40.6514 0 43.8634 0 47.8257C0 51.7879 3.20785 55 7.16493 55Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16504 51.4504C9.16437 51.4504 10.7852 49.8275 10.7852 47.8255C10.7852 45.8236 9.16437 44.2007 7.16504 44.2007C5.1657 44.2007 3.54492 45.8236 3.54492 47.8255C3.54492 49.8275 5.1657 51.4504 7.16504 51.4504Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16497 50.6302C8.71189 50.6302 9.96592 49.3746 9.96592 47.8256C9.96592 46.2767 8.71189 45.021 7.16497 45.021C5.61804 45.021 4.36401 46.2767 4.36401 47.8256C4.36401 49.3746 5.61804 50.6302 7.16497 50.6302Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.117 48.8576C51.545 48.6792 51.747 48.1863 51.5689 47.7578L50.2079 44.4897L48.6577 45.1371L50.0187 48.4052C50.1969 48.8337 50.6891 49.036 51.117 48.8576Z",
    fill: "#E9EBE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6239 46.1167L50.9189 45.1577L48.2885 38.8456L45.9934 39.8046L48.6239 46.1167Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 44.5687C59 44.5687 57.2276 38.1631 49.3151 38.1631L46.5876 41.8597L47.9688 43.6436C48.4207 44.2266 49.1149 44.5687 49.8514 44.5687H59Z",
    fill: "#57B563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0564 38.7256L51.543 44.5684",
    stroke: "#F6F8F5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7373 30.937H7.16483C6.60464 30.937 6.18403 31.4483 6.29424 31.9982L7.21993 36.6787C7.35401 37.361 7.79114 37.944 8.40643 38.2658L12.0963 40.195L12.7392 30.937H12.7373Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35776 32.3554L8.01897 35.7044C8.11815 36.2102 7.73245 36.681 7.21817 36.681L6.29248 32.0005H6.92247C7.13368 32.0005 7.31552 32.1495 7.35592 32.3573L7.35776 32.3554Z",
    fill: "#EA613B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9156 39.9248L6.8913 45.9865C5.82418 47.0605 5.73051 48.7635 6.6709 49.9479C7.44231 50.9189 8.7335 51.3106 9.91266 50.9336L20.0567 47.6803L12.9156 39.9248Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0719 43.5112L40.9177 43.7963V46.3048H24.7273L28.0719 43.5112Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1013 25.1865L40.1077 25.9442L42.0472 29.3539L41.4044 29.6997C40.6862 30.0859 40.4126 30.9778 40.7909 31.7006L42.0307 34.0694C42.4293 34.8307 42.4825 35.7245 42.1776 36.5264C41.274 38.9025 39.4226 43.9619 39.4226 45.5012L48.1469 36.5779L41.1013 25.1884V25.1865Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0719 43.5112L25.1644 46.3048L21.3809 41.8063V35.3438H28.0719L26.4079 38.7001C26.0314 39.4596 26.0791 40.3608 26.5309 41.0781L28.0701 43.5112H28.0719Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97863 29.2805C7.77292 30.3821 8.41026 31.4672 9.47003 31.8239L22.8007 36.315H27.701C28.252 36.315 28.7736 36.0686 29.1245 35.6456L29.4018 35.3109C29.6442 35.0166 29.6369 34.5899 29.3853 34.3049L26.1729 30.6837C25.7504 30.2074 25.1205 29.972 24.4886 30.0529L22.2736 30.3398C20.5214 30.566 18.7471 30.5513 16.9986 30.2938L8.3423 29.0212C8.17149 28.9954 8.01169 29.1113 7.97863 29.2805Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8946 34.06L45.7115 27.4116C43.5993 24.7008 39.7661 24.0645 36.8917 25.944L38.8808 26.676C40.8204 27.3914 42.4385 28.7799 43.4377 30.5896L44.727 32.9216C46.0549 35.3234 45.7335 38.3009 43.9244 40.3626L40.1702 44.644C39.6945 45.1865 39.0094 45.4973 38.2876 45.4973H26.9644C26.1875 45.4973 25.4528 45.135 24.9789 44.5189L23.4894 42.5805C23.1239 42.106 23.0577 41.4642 23.3185 40.9235L24.2461 38.9961C24.4242 38.6283 24.4353 38.2016 24.2773 37.8246L23.7612 36.5942C22.7326 34.1409 20.5396 32.3717 17.926 31.8898L12.9559 30.9721C12.6823 30.9206 12.3994 30.9409 12.1331 31.0291L10.1513 31.6875C9.54337 31.8898 9.13379 32.4581 9.13379 33.1V36.3496C9.13379 36.7193 9.27154 37.0761 9.51949 37.3501L20.5341 49.5065C21.0888 50.119 21.8767 50.4684 22.7051 50.4684H40.0104C40.9361 50.4684 41.8067 50.0307 42.3595 49.2895L50.9369 37.7749C51.7615 36.6678 51.745 35.145 50.8964 34.0581L50.8946 34.06Z",
    fill: "#F6F8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3471 50.4814H38.9011V50.1725H35.3471V50.4814Z",
    fill: "#D7D9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6818 50.4814H34.2358V50.1725H30.6818V50.4814Z",
    fill: "#D7D9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0168 50.4814H29.5708V50.1725H26.0168V50.4814Z",
    fill: "#D7D9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2418 48.3555H29.2161L28.397 49.2732H40.5559L40.2418 48.3555Z",
    fill: "#57B563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.698 31.2427L44.9934 33.4661",
    stroke: "#E9EBE7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1838 45.3262L21.7922 50.3267",
    stroke: "#E9EBE7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3765 44.7323L17.0427 38.8472L20.2918 40.907C20.931 41.3116 21.7153 41.4182 22.4389 41.1957L23.3187 40.9253C23.0579 41.466 23.124 42.106 23.4895 42.5824L24.9791 44.5208C25.4529 45.1387 26.1876 45.4992 26.9645 45.4992H24.1066C23.4473 45.4992 22.8191 45.2196 22.3765 44.7323Z",
    fill: "#E9EBE7"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3648 45.4955C37.946 45.7934 37.4428 45.9589 36.9193 45.9589H25.5961C24.8192 45.9589 24.0845 45.5966 23.6107 44.9805L22.1211 43.0421C21.7556 42.5676 21.6895 41.9258 21.9503 41.3851L22.8778 39.4577C23.056 39.0899 23.067 38.6632 22.909 38.2862L22.3929 37.0559C21.3644 34.6025 19.1714 32.8333 16.5578 32.3515L11.5877 31.4338C11.314 31.3823 11.0312 31.4025 10.7648 31.4908L10.1055 31.7096C10.1202 31.7041 10.1349 31.6949 10.1514 31.6912L12.1332 31.0328C12.3977 30.9446 12.6805 30.9262 12.956 30.9758L17.9261 31.8935C20.5397 32.3754 22.7327 34.1446 23.7613 36.5979L24.2774 37.8283C24.4353 38.2053 24.4243 38.632 24.2461 38.9998L23.3186 40.9272C23.0578 41.4679 23.1239 42.1079 23.4894 42.5842L24.979 44.5226C25.4529 45.1405 26.1875 45.501 26.9644 45.501H38.2876C38.3134 45.501 38.3391 45.4973 38.3648 45.4973V45.4955Z",
    fill: "#454545"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.5087 30.349V31.2409C13.5087 31.3881 13.3894 31.5095 13.2406 31.5095H12.4747C12.4545 31.5095 12.4343 31.5076 12.4141 31.5021L7.57807 30.3692C7.19052 30.2791 6.94441 29.9002 7.01604 29.5085C7.03624 29.3963 7.14093 29.3191 7.25481 29.332L13.2736 30.0823C13.4077 30.0989 13.5087 30.2129 13.5087 30.3471V30.349Z",
    fill: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2061 45.3262L40.9178 50.3267",
    stroke: "#E9EBE7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4568 46.6672C15.0426 46.4446 13.8597 45.4718 13.3657 44.1274L12.8679 42.772L9.6335 46.0272C9.22943 46.4336 9.07698 47.0442 9.28636 47.5775C9.56738 48.2929 10.348 48.6295 11.0349 48.4088L16.4568 46.6709V46.6672Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1643 21.8485C34.1643 22.2016 34.4508 22.4885 34.8035 22.4885C35.1561 22.4885 35.4426 22.2016 35.4426 21.8485C35.4426 21.4954 35.1561 21.2085 34.8035 21.2085C34.4508 21.2085 34.1643 21.4954 34.1643 21.8485Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5164 20.4141L40.7322 22.1961C40.9784 22.5566 41.3861 22.7718 41.8214 22.7718H43.9612",
    stroke: "#F6F8F5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4791 47.2426C18.4644 47.2261 18.6278 46.6118 18.7546 46.1447C18.8446 45.8173 18.7601 45.4679 18.5323 45.2159L14.0967 40.2908C13.8892 40.061 13.5861 39.9396 13.2775 39.9653L11.979 40.0701L18.4791 47.2445V47.2426Z",
    fill: "#57B563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7564 43.4633C42.9511 43.6233 43.2394 43.5957 43.3992 43.4008L43.9594 42.7203C44.1192 42.5254 44.0917 42.2366 43.897 42.0766C43.7023 41.9166 43.4139 41.9442 43.2541 42.1392L42.6939 42.8196C42.5341 43.0146 42.5617 43.3033 42.7564 43.4633Z",
    fill: "#EA613B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3145 49.2729C17.3145 49.374 17.3953 49.455 17.4963 49.455C17.5973 49.455 17.6781 49.374 17.6781 49.2729C17.6781 49.1717 17.5973 49.0908 17.4963 49.0908C17.3953 49.0908 17.3145 49.1717 17.3145 49.2729Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8234 43.6523L15.4961 43.9507L17.534 46.1917L17.8613 45.8933L15.8234 43.6523Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0578 40.6122L12.7305 40.9106L14.7684 43.1516L15.0957 42.8532L13.0578 40.6122Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5768 37.9307C16.2668 37.2398 16.2668 36.1196 15.5768 35.4287C14.8867 34.7377 13.768 34.7377 13.078 35.4287C12.388 36.1196 12.388 37.2398 13.078 37.9307C13.768 38.6216 14.8867 38.6216 15.5768 37.9307Z",
    fill: "#E9EBE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3832 35.3438L13.1489 36.9364H14.2032L13.7991 38.0141L15.3842 36.2854L14.2675 36.2412L14.3832 35.3438Z",
    fill: "#57B563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3157 28.186L50.8946 34.0601C50.2315 34.4831 49.3554 34.3323 48.8706 33.7144L46.5508 30.7534C45.9759 30.0178 45.8841 29.0136 46.3157 28.1879V28.186Z",
    fill: "#D7D9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8496 48.3555H28.1583L27.3409 49.2732H25.0322L25.8496 48.3555Z",
    fill: "#57B563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6518 39.2261L33.3983 42.965H31.4092L31.76 39.2261H33.6518Z",
    fill: "#FE7A63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4792 41.7585C33.4792 41.7585 32.7978 41.5304 32.3901 42.3874C32.166 42.8564 31.424 42.5382 31.424 42.5382C31.424 42.5382 30.8987 43.0716 30.8987 44.1695H36.1516C36.1516 44.1695 36.1296 43.7006 36.0028 43.5295C35.8743 43.3585 34.2874 43.1635 33.8686 43.0532C33.5986 42.9815 33.4792 41.7585 33.4792 41.7585Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1516 44.1694H30.8987V44.5317H36.1516V44.1694Z",
    fill: "#FDBD51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8383 43.2334C34.8383 43.2334 34.8806 43.787 34.46 43.752C34.0412 43.7171 32.9961 43.4743 32.9465 44.1713",
    stroke: "#26355B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7437 42.2607L33.1467 42.4097",
    stroke: "#26355B",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8117 42.54L33.2368 42.7589",
    stroke: "#26355B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8705 42.8066L33.3416 43.1211",
    stroke: "#26355B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1577 42.9502C31.1577 42.9502 31.9824 43.2518 31.9108 44.1695",
    stroke: "#26355B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8099 28.4988C35.2882 27.4873 25.4546 25.9517 25.4546 25.9517L19.4045 26.0399C19.4045 26.0399 18.477 30.9485 20.907 30.9945C22.9365 31.0331 33.0622 30.9945 33.0622 30.9945L31.6332 41.8801H33.8134C33.8134 41.8801 36.2911 29.4331 35.8099 28.4988Z",
    fill: "#546F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0191 40.8242H31.771",
    stroke: "#0D0000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2079 10.6797C26.544 12.5041 26.9168 13.1275 27.2566 14.5602C27.6423 16.1859 28.928 19.1027 28.928 19.1027C28.928 19.1027 26.3493 20.4048 25.0324 20.3791C25.0324 20.3791 24.4134 19.5552 24.8102 19.2204C24.8102 19.2204 23.6806 13.659 24.0296 12.4765C24.3785 11.2939 26.2079 10.6815 26.2079 10.6815V10.6797Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5479 18.2104L24.7275 19.8068",
    stroke: "#0D0000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9452 10.2914L23.9799 8.77783C23.9799 8.77783 20.3433 10.6335 19.3202 11.9245C17.1125 14.7126 16.6809 26.0377 16.6809 26.0377L25.4548 25.9495C25.6678 24.9122 26.6615 14.9517 26.9994 13.5374C27.3392 12.1231 25.9452 10.2896 25.9452 10.2896V10.2914Z",
    fill: "#D84F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7505 19.0088L21.4526 23.6231",
    stroke: "#0D0000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7505 20.6309L24.272 23.1192",
    stroke: "#0D0000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8454 14.0654L18.5046 26.014L18.9767 26.0398L20.5819 14.0654H19.8454Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.247 9.13646C23.247 9.13646 23.9926 10.6353 24.8283 10.959C25.7614 11.3195 26.2059 10.6795 26.2059 10.6795L25.9432 10.2914L23.978 8.77783L23.2451 9.13646H23.247Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7418 12.1582L23.844 9.40137C23.844 9.40137 24.3362 9.73792 24.3362 9.817C24.3362 9.89608 21.5114 12.4377 21.5114 12.4377L20.74 12.1582H20.7418Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0129 15.2755C23.7429 13.8281 21.9723 11.6433 20.9989 11.9578C20.9989 11.9578 20.0273 12.561 19.8528 13.7803C19.6783 14.9996 21.897 21.2103 21.897 21.2103L26.0516 19.4319C26.0516 19.4319 24.2829 16.721 24.0147 15.2755H24.0129Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2079 10.6796L27.2162 5.87402L24.7275 5.87954L23.98 8.77979C23.98 8.77979 24.1085 10.6171 26.2079 10.6796Z",
    fill: "#D47050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1464 6.85242C25.1464 6.85242 24.6725 9.02991 26.4743 9.39957L26.9849 6.96829L25.1464 6.85059V6.85242Z",
    fill: "#0D0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7847 3.24776L28.6396 6.39997C28.5919 7.42986 27.7194 8.22435 26.6927 8.17838C26.0223 8.14711 25.4126 7.78113 25.0709 7.20182L24.6301 6.45698L24.7862 3.06201L28.7847 3.24776Z",
    fill: "#D47050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4393 5.99161C26.5133 5.99161 26.5733 5.87139 26.5733 5.7231C26.5733 5.57481 26.5133 5.45459 26.4393 5.45459C26.3652 5.45459 26.3052 5.57481 26.3052 5.7231C26.3052 5.87139 26.3652 5.99161 26.4393 5.99161Z",
    fill: "#491800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9381 5.7231C27.9381 5.87206 27.8775 5.99161 27.804 5.99161C27.7305 5.99161 27.6699 5.87206 27.6699 5.7231C27.6699 5.57413 27.7305 5.45459 27.804 5.45459C27.8775 5.45459 27.9381 5.57413 27.9381 5.7231Z",
    fill: "#491800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2007 7.13383L27.8041 7.04004C27.8041 7.04004 27.5745 7.86947 26.9868 7.88051C26.3972 7.89338 26.2025 7.13383 26.2025 7.13383H26.2007Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0675 5.24658C27.0675 5.24658 27.3063 6.36291 27.2328 6.5597C27.1832 6.69027 26.9683 6.73257 26.9004 6.73809",
    stroke: "#2C1817",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5734 4.73722C26.5789 4.81078 26.1766 4.89538 25.9379 4.91193C25.6973 4.92849 25.6109 4.87515 25.6073 4.80159C25.6017 4.72803 25.8919 4.65078 26.1307 4.63423C26.3713 4.61768 26.5697 4.66366 26.5734 4.73722Z",
    fill: "#491800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4129 4.68235C27.4184 4.75592 27.8261 4.78718 28.0668 4.77063C28.3074 4.75408 28.3845 4.68971 28.3808 4.61798C28.3753 4.54442 28.0796 4.5058 27.839 4.52235C27.5984 4.5389 27.4092 4.61063 27.4129 4.68235Z",
    fill: "#491800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9314 5.6221C24.9131 6.00463 24.5916 6.28417 24.2133 6.24371C23.8349 6.20509 23.541 5.86302 23.5594 5.48049C23.5778 5.09796 23.8992 4.81841 24.2776 4.85887C24.6559 4.89749 24.9498 5.23957 24.9314 5.6221Z",
    fill: "#FE7A63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9524 5.49336C24.204 5.41428 24.4373 5.43267 24.6136 5.81153",
    stroke: "#2C1817",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9313 5.62195C25.4291 5.64586 25.4548 4.03849 25.4934 3.74424C25.8442 4.17091 26.9297 4.57735 27.2841 4.51482C27.657 4.44861 27.7047 4.13045 27.4586 3.95941C27.6919 4.18378 28.7682 4.68401 29.0106 4.57367C29.288 4.44677 29.1153 2.88354 28.6819 2.69043C28.2484 2.49733 24.913 2.56538 24.6669 2.90745C24.3712 3.32124 24.3271 5.59621 24.9295 5.62379L24.9313 5.62195Z",
    fill: "#75332F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6332 40.2266L31.3798 43.9654H29.3906L29.7414 40.2266H31.6332Z",
    fill: "#FE7A63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4607 42.759C31.4607 42.759 30.7793 42.5309 30.3715 43.3879C30.1474 43.8569 29.4054 43.5387 29.4054 43.5387C29.4054 43.5387 28.8801 44.0721 28.8801 45.17H34.1331C34.1331 45.17 34.111 44.701 33.9843 44.53C33.8557 44.359 32.2688 44.164 31.8501 44.0537C31.5801 43.982 31.4607 42.759 31.4607 42.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1331 45.1699H28.8801V45.5322H34.1331V45.1699Z",
    fill: "#FDBD51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8198 44.2319C32.8198 44.2319 32.862 44.7855 32.4414 44.7506C32.0208 44.7156 30.9776 44.4729 30.928 45.1699",
    stroke: "#26355B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7251 43.2612L31.1282 43.4102",
    stroke: "#26355B",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7949 43.5405L31.22 43.7594",
    stroke: "#26355B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.852 43.8071L31.323 44.1216",
    stroke: "#26355B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1392 43.9507C29.1392 43.9507 29.9638 44.2523 29.8922 45.17",
    stroke: "#26355B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.111 29.3301C34.111 28.4988 22.9458 25.9517 22.9458 25.9517L16.679 26.0399C16.679 26.0399 15.7514 30.9485 18.1814 30.9945C20.2109 31.0331 30.3366 30.9945 30.3366 30.9945L28.735 42.9596H31.9382C31.9382 42.9596 34.1073 30.3802 34.1073 29.3301H34.111Z",
    fill: "#607EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5398 20.9292C22.5398 20.9292 22.6261 21.8487 23.3186 21.8487C25.0175 21.8487 33.492 21.1885 33.492 21.1885L33.7399 19.9066L26.0515 19.4321L22.5398 20.9292Z",
    fill: "#D47050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7382 19.9062C33.7382 19.9062 35.2388 19.6836 35.6483 19.645C35.9606 19.6156 36.8899 20.96 36.8477 21.1108C36.8055 21.2597 36.3591 21.1108 36.3591 21.1108C36.3591 21.1108 36.3738 21.4105 36.2324 21.4013C36.091 21.3921 35.9459 21.2671 35.9459 21.2671C35.9459 21.2671 36.1112 21.6423 35.9459 21.6496C35.7806 21.657 35.4977 21.1567 35.4977 21.1567C35.4977 21.1567 33.9641 21.6809 33.4902 21.1898L33.7382 19.908V19.9062Z",
    fill: "#D47050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6069 20.3788L25.5962 18.6997",
    stroke: "#0D0000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7212 25.1865H25.5961",
    stroke: "#0D0000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0517 19.4321L25.5962 20.0519",
    stroke: "#0D0000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7185 26.0308C17.7185 26.0308 17.2153 29.5122 18.5047 29.9296C19.794 30.3453 30.8527 29.9719 31.1282 30.4262C31.4019 30.8805 30.7499 34.4557 29.1373 42.8953",
    stroke: "#7397C9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8525 42.0952H32.0888",
    stroke: "#0D0000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3384 30.9943L30.5533 29.7603",
    stroke: "#0D0000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.4845 3.55664C29.4845 3.55664 30.6104 4.6601 29.9198 5.87206H24.7881V3.55664H29.4845Z",
    fill: "#4C5054"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.377 5.8739H27.2309L26.656 3.55664H27.8039L28.377 5.8739Z",
    fill: "#F6F8F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.4219 5.8739H28.8764L28.3015 3.55664H28.847L29.4219 5.8739Z",
    fill: "#F6F8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4862 3.27336C29.4898 3.36531 29.488 3.46095 29.4843 3.55658L26.024 3.54922C25.4712 3.54003 24.9257 4.06417 25.1277 4.57728C25.4712 5.45269 25.3683 5.82786 24.7255 6.24534C24.5363 6.36672 24.1983 6.37223 23.8273 6.24718C23.8255 6.24534 23.8237 6.24534 23.8237 6.24534C22.9531 5.95476 22.1413 4.31245 22.4884 2.94048C23.1716 0.237011 25.8459 -0.22828 27.0728 0.0843658C28.3144 0.40069 29.4513 1.50231 29.4862 3.27336Z",
    fill: "#57B563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.71 0.0478516C25.71 0.0478516 27.8093 1.07039 27.8093 3.27363H28.4632C28.4632 3.27363 28.0903 0.0478516 25.71 0.0478516Z",
    fill: "#60C76D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.656 0.0478516C26.656 0.0478516 28.7553 1.07039 28.7553 3.27363H29.4092C29.4092 3.27363 29.0382 0.0478516 26.656 0.0478516Z",
    fill: "#60C76D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4881 3.27381V3.55703H29.4844L26.0241 3.54968C25.4712 3.54048 24.9257 4.06462 25.1278 4.57773C25.4712 5.45314 25.3684 5.82832 24.7255 6.24579C24.5364 6.36717 24.1984 6.37269 23.8274 6.24763C23.8256 6.24579 23.8237 6.24579 23.8237 6.24579C25.0617 6.0674 25.0378 5.24348 24.7274 4.37175C24.5198 3.78876 25.1792 3.27197 25.6512 3.27197H29.4899L29.4881 3.27381Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9137 5.46205C24.2149 5.46205 24.4592 5.2175 24.4592 4.91584C24.4592 4.61418 24.2149 4.36963 23.9137 4.36963C23.6124 4.36963 23.3682 4.61418 23.3682 4.91584C23.3682 5.2175 23.6124 5.46205 23.9137 5.46205Z",
    fill: "#60C76D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkada);
export default __webpack_public_path__ + "static/media/okada.0fead8badb69308a20b7aeeb5d4093f1.svg";
export { ForwardRef as ReactComponent };